// extracted by mini-css-extract-plugin
module.exports = {"spinning":"Spinner_spinning__PMJpG"};